import Base from '@studiometa/js-toolkit';

/**
 * StickyBanner (fiche pge)
 */
export default class StickyBanner extends Base {
  /**
   * Config
   */
  get config() {
    return {
      name: 'StickyBanner',
    };
  }

  stickyIsVisible = false;

  /**
   * Open cookie panel
   * @return {boolean} prevent url redirection
   */
  mounted() {
    this.hero = document.querySelector('.hero');
    this.hitScroll = this.hero.offsetTop + this.hero.clientHeight;
  }

  /**
   * Detect scroll
   * @param  {Object} options.y
   * @return {void}
   */
  scrolled({ y }) {
    if (y >= this.hitScroll && !this.stickyIsVisible) {
      this.stickyIsVisible = true;
      this.$el.style.transform = 'translateY(0)';
      return;
    }

    if (y < this.hitScroll && this.stickyIsVisible) {
      this.stickyIsVisible = false;
      this.$el.style.transform = 'translateY(102%)';
    }
  }
}
